<template>
    <div class="cpc-intro">
        <div class="a-container">
            <div class="spotlight-item">
                <dynamic-link :to="spotlightedCard.link" native-type="a">
                    <a-picture :link="spotlightedCard.image_id" fit="cover" is-background />
                </dynamic-link>
            </div>
        </div>
        <div class="spotlight-info-wrapper">
            <div class="a-container">
                <div class="spotlight-info">
                    <dynamic-link :to="spotlightedCard.link" native-type="a">
                        <div class="title">
                            {{ spotlightedCard.title }}
                        </div>
                        <div class="description">
                            {{ spotlightedCard.description }}
                        </div>
                    </dynamic-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicLink from '@core/components/dynamic-link/dynamic-link.vue';
import APicture from '@core/components/picture/picture.vue';
import breakpoints from '@core/mixins/breakpoint.js';

export default {
    name: 'SBlogCpcIntro',
    components: {
        APicture,
        DynamicLink,
    },
    mixins: [breakpoints],
    props: {
        spotlightedCard: {
            type: Object,
            required: true,
        },
        links: {
            type: Array,
            required: true,
        },

        title: {
            type: String,
            default: null,
        },
    },
};
</script>

<style lang="postcss" scoped>
.cpc-intro {
    .spotlight-item {
        display: block;
        position: relative;
        min-height: 418px;
        border-bottom: 2px solid var(--av-nav-secondary);
    }
}
.spotlight-info-wrapper {
    background: var(--av-app-base);
    .spotlight-info {
        top: -90px;
        padding: 16px;
        transform: unset;
        position: relative;
        margin-bottom: -90px;
        inset-inline-start: 0;
        width: calc(100% - 32px);
        color: var(--av-inversed-primary);
        background: var(--av-nav-secondary);
        @media (--viewport-tablet) {
            width: calc(100% - 96px);
        }
        @media (--viewport-desktop) {
            width: 765px;
        }
        .title {
            @mixin display-accent;
            margin-bottom: 8px;
        }
        .description {
            @mixin paragraph;
        }
    }
}
</style>
